import {Injectable, inject} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable, map} from "rxjs";
import {AccountModel} from "../../../account/angular/models/account.model";
import {toCursorPage} from "./threepl-train-http.service";

export interface SupplyAccountsQuery {
  type: string;
  query?: string;
  limit: number;
  cursor?: string;
}

@Injectable({providedIn: "root"})
export class ThreePLSupplyAccountsHttpService {
  private readonly http = inject(HttpClient);

  list(query: SupplyAccountsQuery): Observable<{list: AccountModel[]; cursor: string}> {
    let params = new HttpParams()
      .set("limit", query.limit)
      .set("isSupply", true)
      .set("type", query.type)
      .set("sort", "name,asc");
    if (query.query) {
      params = params.set("query", query.query);
    }
    if (query.cursor) {
      params = params.set("cursor", query.cursor);
    }
    return this.http.get<unknown>("/accounts", {params}).pipe(map((r) => toCursorPage<AccountModel>(r)));
  }

  getOne(accountId: string): Observable<AccountModel> {
    return this.http.get<AccountModel>(`/accounts/${accountId}`);
  }
}
